const resolveRuntimeHost = (configuredUrl?: string) => {
  if (!configuredUrl || typeof window === 'undefined') return configuredUrl

  const browserHost = window.location.hostname
  return configuredUrl.replace(
    /\/\/(localhost|127\.0\.0\.1)(?=[:/]|$)/,
    `//${browserHost}`,
  )
}

export const backendUrl = resolveRuntimeHost(process.env.REACT_APP_API_URL)
export const shortUrl = resolveRuntimeHost(process.env.REACT_APP_SHORT_URL)
export const mediaUrl = resolveRuntimeHost(process.env.REACT_APP_MEDIA_URL)
